import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner container">
        <div className="footer-left">
          <div className="brand">STARGATE</div>
          <p className="tag">
            Professional insurance consultancy — trusted since decades.
          </p>
        </div>

        <div className="footer-links">
          <h4>Navigation</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>
          <p>info@stargate-broker.com</p>
          <div className="social">
            <a
              href="https://www.facebook.com/stargateinsurancelb"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.youtube.com/@StarGateLebanon"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a href="mailto:info@stargate-broker.com" aria-label="Email">
              <FaEnvelope />
            </a>
            <a
              href="https://www.instagram.com/stargate.broker/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          © {new Date().getFullYear()} STARGATE S.A.R.L. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
